import { css } from 'emotion';

import { colors } from '../styles';

const activityProgressBar = css`
  display: grid;
  width: 100%;
  grid-row-gap: 4px;
`;

const progressWrapper = (done: number, notDone: number, waiting: number) => css`
  display: grid;
  grid-template-columns: ${done}% ${notDone}% ${waiting}%;
  border-radius: 5px;
  overflow: hidden;
  background-color: ${colors.gray.light};

  > div {
    height: 15px;
  }

  > div:first-child {
    background-color: ${colors.success.default};
  }

  > div:not(:first-child):not(:last-child) {
    background-color: ${colors.warning.default};
    border-radius: 0 5px 5px 0;
  }
`;

const progressInfo = css`
  display: flex;
  justify-content: space-between;
`;

export default {
  activityProgressBar,
  progressWrapper,
  progressInfo,
};
